import React, { Suspense, lazy } from 'react';
import { Route, Switch, HashRouter } from 'react-router-dom';
import App from '../App.tsx';
import Admin from '../pages/Admin';
import Loading from '../components/Loading';
const Page1 = lazy(() => import('../pages/Page1'));
const Page2 = lazy(() => import('../pages/Page2'));
const Page3 = lazy(() => import('../pages/Page3'));
const Page4 = lazy(() => import('../pages/Page4'));
const Page5 = lazy(() => import('../pages/Page5'));
const Page6 = lazy(() => import('../pages/Page6'));
// const Page7 = lazy(() => import('../pages/Page7'));
// const Page8 = lazy(() => import('../pages/Page8'));
// const Page9 = lazy(() => import('../pages/Page9'));
// const Page10 = lazy(() => import('../pages/Page10'));
// const Page11 = lazy(() => import('../pages/Page11'));
// const Page12 = lazy(() => import('../pages/Page12'));
const Page13 = lazy(() => import('../pages/Page13'));
const Map = lazy(() => import('../pages/Map'));
const NotFound = lazy(() => import('../pages/NotFound'));

function Router() {
	return <HashRouter>
		<Suspense fallback={<Loading />}>
			<Switch>
				<App>
					<Switch>
						<Route path="/" render={() =>
							<Admin>
								<Switch>
									<Route exact path='/' component={Page1} />
									<Route path='/page2' component={Page2} />
									<Route path='/page3' component={Page3} />
									<Route path='/page4' component={Page4} />
									<Route path='/page5' component={Page5} />
									<Route path='/page6' component={Page6} />
									{/* <Route path='/page7' component={Page7} /> */}
									{/* <Route path='/page8' component={Page8} /> */}
									{/* <Route path='/page9' component={Page9} /> */}
									{/* <Route path='/page10' component={Page10} /> */}
									{/* <Route path='/page11' component={Page11} /> */}
									{/* <Route path='/page12' component={Page12} /> */}
									<Route path='/page13' component={Page13} />
									<Route path='/map' component={Map} />
									<Route component={NotFound} />
								</Switch>
							</Admin>
						}
						/>
					</Switch>

				</App>
			</Switch>
		</Suspense>
	</HashRouter>
}

export default Router;